import { useMutation } from "react-query";
import { addOfficeVendorService } from "../../../../actions/CarrierAgreementMgmt/OfficeVendorService";

const useAddOfficeVendorService = () => {
  return useMutation(addOfficeVendorService);
};
export default useAddOfficeVendorService;
